import { apiGet, apiPatch } from '../api/apiClient';

export interface NotificationItem {
  _id: string;
  recipient: string;
  sender: {
    _id: string;
    name: string;
    profilePictureId?: {
      url: string;
    };
    email: string;
  };
  type: 'feed_creation' | 'admin_post';
  feedId: string;
  description: string;
  isRead: boolean;
  createdAt: string;
}

export interface NotificationsResponse {
  success: boolean;
  message: string;
  data: {
    notifications: NotificationItem[];
    pagination: {
      current: number;
      pages: number;
      total: number;
      limit: number;
    };
  };
}

export interface UnreadCountResponse {
  success: boolean;
  data: {
    count: number;
  };
}

export const notificationService = {
  getNotifications: (page = 1, limit = 20) =>
    apiGet<NotificationsResponse>(`/notifications?page=${page}&limit=${limit}`, { showLoader: false }),

  getUnreadCount: () =>
    apiGet<UnreadCountResponse>('/notifications/unread-count', { showLoader: false }),

  markAsRead: (id: string) =>
    apiPatch<{ success: boolean }>(`/notifications/${id}/read`, {}, { showLoader: false }),
};
